export default "__VITE_ASSET__DgKk6Sf___"